import { useEffect, useRef } from 'react';
import { Tabs, TabsList, TabsTrigger } from '@/shared/components/ui/tabs';
import type {
  OperationFilter,
  OperationHistoryFilterItem,
} from '@/shared/types';
import { cn } from '@/shared/utils';

type Props = {
  onValueChange: (value: OperationFilter) => void;
  value: OperationFilter;
  options: OperationHistoryFilterItem[];
  className?: string;
};

const TAB_TRIGGER_CLASSNAME =
  'h-[2.8rem] flex-none rounded-[0.8rem] px-[1.2rem] py-0 medium5 data-[state=active]:bg-secondary-bg data-[state=active]:shadow-none';

export const HistoryOperationTypeTabs = ({
  onValueChange,
  value,
  options,
  className,
}: Props) => {
  const listRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    listRef.current
      ?.querySelector<HTMLElement>('[data-state="active"]')
      ?.scrollIntoView({
        behavior: 'smooth',
        inline: 'nearest',
        block: 'nearest',
      });
  }, [value]);

  return (
    <Tabs
      value={value}
      onValueChange={nextValue => onValueChange(nextValue as OperationFilter)}
      className="min-w-0 tablet:flex-1">
      <TabsList
        ref={listRef}
        className={cn(
          'h-[2.8rem] w-auto justify-start gap-[0.2rem] overflow-x-auto rounded-none bg-transparent p-0 scrollbar-hide',
          className
        )}>
        {options.map(({ name, filter }) => (
          <TabsTrigger
            key={filter}
            value={filter}
            className={TAB_TRIGGER_CLASSNAME}>
            {name}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
};
